import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import headerImg from "./assets/header.png";
import headerImgMb from "./assets/header-mb.png";
import kanbanImg from "./assets/kanban.png";
import aboutImg from "./assets/about.png";
// import ProxyParser from './utils/ProxyParser'

const EVENT_ID = "s0005";

const aboutWalkContent = `無論是重要家族展現的傳統伙房空間，或者曾經在歷史發展源流中所留下的建物，以及呈現不同時期的防禦空間…等，這些歷經長時間的發展所留下的有形建物，都是我們可以在佳冬客庄可見到的。本次《𠊎佇茄苳腳》所展示的數位走讀地圖，將呈現及介紹佳冬客庄的6大家族（伙房foˋ fongˇ）外，包含有3個古蹟（蕭宅、楊氏宗祠、西隘門）、4個重要的歷史建築（蕭屋洋樓、張家商樓、神社及防空洞）、1個防禦有關的空間(偵測站)及1個戰役的代表建物(步月樓)。民眾可在瀏覽各特色景點介紹時，亦可透過「導航」走訪各處，為自己留下專屬在佳冬客庄的走讀體驗紀錄。此外，佳冬還有更多的人文故事及傳統聚落，等待更多人一起來挖掘及遊賞。`;

const credit = `
<div>
    <ul>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺由客家委員會客家文化發展中心（以下簡稱客發中心）及智紳數位文化事業有限公司共同協力建置：
            <br><br>1. 圖臺內容：由客家委員會客家文化發展中心提供。
            <br><br>2. 圖臺系統開發：智紳數位文化事業有限公司。
        </li>
        <br><br>
        <li style="list-style-type: cjk-ideographic;">
        本圖臺之內容著作權由客家委員會客家文化發展中心所有，若有其他利用或授權需求請洽客發中心。
        </li>
    </ul>
</div>
電話：08-7230100（分機306）`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "佳冬客庄的6大家族數位走讀",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "屏東縣", town: "佳冬鄉" }],
  },
  themeConfig: {
    "--dui-primary": "#28A4F2",
    "--dui-accent": "#ED9228", //'#f8936e',
    "--dui-secondary": "#28A4F2",
    "--dui-bg-secondary": "#EB9D1D",
    "--dui-bg-accent": "#B0DA62",
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);
  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="checkin list"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist?a=${EVENT_ID}`}
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        latLng(22.396110273266395, 120.53418159484865),
        latLng(22.461326119937894, 120.58061599731447),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider
          {...duiConfigProps}
          sceneConfig={{ cluster: false, checkinKanbanImgSrc: kanbanImg }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
